var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWishlistTransparent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.1,
  d: "m10 19.263 1.055-1.141C17.7 11.73 19.5 9.35 19.5 5.976 19.5 2.879 17.312.5 14.502.5c-1.54 0-3.097.792-4.107 2.09L10 3.097l-.395-.507C8.595 1.292 7.038.5 5.497.5 2.688.5.5 2.879.5 5.976c0 3.374 1.799 5.754 8.466 12.167z"
})));
export { SvgWishlistTransparent as ReactComponent };
export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvbWVkaWEvd2lzaGxpc3RfdHJhbnNwYXJlbnQuMzU3MDY5YzAuc3ZnIjs=";